var kind          = require("enyo/kind"),
    utils         = require("enyo/utils"),
    AnimationLoop = require("enyo-anim/AnimationLoop");

/**
 * [AnimationSupport]{@link enyo-anim.AnimationSupport} adds some simple helper
 * methods to schedule and cancel animationFrames using [AnimationLoop]{@link
 * enyo-anim.AnimationLoop}.
 *
 * Each scheduled callback should be given a name. The same name can be used to
 * cancel the callback as needed.
 *
 * @mixin enyo-anim.AnimationSupport
 * @protected
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-anim.AnimationSupport",

    /**
     * @method
     * @private
     */
    constructed: kind.inherit(function(sup) {
        return function() {
            this.euid = this.euid || utils.uid();
            sup.apply(this, arguments);
        };
    }),

    /**
     * Schedule a named callback to be executed on the next animationFrame.
     *
     * @param {string}    name      The name for this callback
     * @param {Function}  callback  The callback
     * @public
     */
    requestAnimationFrame: function(name, callback) {
        AnimationLoop.request(this.euid + "::" + name, callback);
    },

    /**
     * Check if the named callback is scheduled to execute on the next
     * animationFrame.
     *
     * @param   {string}  name  The named of the callback
     * @returns {boolean}  Whether the callback is scheduled
     * @public
     */
    hasAnimationFrame: function(name) {
        return AnimationLoop.isScheduled(this.euid + "::" + name);
    },

    /**
     * Cancel execution of the named callback from on the next animationFrame.
     *
     * @param {string}  name  The named of the callback
     * @public
     */
    cancelAnimationFrame: function(name) {
        AnimationLoop.cancel(this.euid + "::" + name);
    }

};
